import * as api from '@owl-nest/api-client/latest'
import { ACTION_TYPE, ChannelAction } from '../actions/channel'
import { Status } from '@owl-nest/redux-wrapper'

export type State = {
  channels: api.Channel[]
  next: string | null
  status: {
    load: Status
  }
}

export const initialState: State = {
  channels: [],
  next: null,
  status: {
    load: Status.PRISTINE,
  },
}

export function reducer(state = initialState, action: ChannelAction): State {
  switch (action.type) {
    case ACTION_TYPE.LOAD_CHANNELS_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: Status.PENDING,
        },
      }
    }
    case ACTION_TYPE.LOAD_CHANNELS_FAILURE: {
      return {
        ...state,
        channels: [],
        next: null,
        status: {
          ...state.status,
          load: Status.FAILURE,
        },
      }
    }
    case ACTION_TYPE.LOAD_CHANNELS_SUCCESS: {
      if (action.success.forceClean) {
        return {
          ...state,
          channels: action.success.channels,
          next: action.success.meta.next,
          status: {
            ...state.status,
            load: Status.SUCCESS,
          },
        }
      }
      return {
        ...state,
        channels: state.channels.concat(action.success.channels),
        next: action.success.meta.next,
        status: {
          ...state.status,
          load: Status.SUCCESS,
        },
      }
    }
    default:
      return state
  }
}
